module.exports = __webpack_public_path__ + "static/media/hifi_prototype.1b9e3de8.jpg";